const groups = document.querySelectorAll('[name="faq-group"]')
const faqs = document.querySelectorAll('.collapsible-content__grid')

groups.forEach( group => {
    group.addEventListener('change', () => {
      let groupName = group.dataset.group
      faqs.forEach( faq => {faq.style.display = 'none'} )
      let faqToShow = Array.from(faqs).find( faq => { /* console.log(faq.dataset.group,"==",groupName);*/ return faq.dataset.group == groupName } )
      if(faqToShow) faqToShow.style.display = 'block'
    })
})